import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';

@Component({
    selector: 'button-component',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {

    @Input() type: string = 'default';
    @Input() textSize: string = 'default';
    @Input() active: boolean = false;
    @Input() disable: boolean = false;
    @Input() hide: boolean = false;
    @Input() color: number = 0;

    @Output() onClick = new EventEmitter();

    constructor() {
    }

    ngOnInit() {
    }

    click(){
        this.onClick.emit();
    }





}



// WEBPACK FOOTER //
// ./src/app/components/button/button.component.ts